import React, { useEffect, useState } from "react";
import { getAuth, signInWithCustomToken } from "firebase/auth";

import { setAuthToken } from "../../api/api";
import { useNavigate } from "react-router-dom";

export default function Auth() {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const redirectUrl = params.get("redirect") || "/";

    if (!token) {
      setError("No token provided");
      setLoading(false);
      return;
    }

    setAuthToken(token); // Attach token to all API requests

    const auth = getAuth();
    signInWithCustomToken(auth, token)
      .then(() => navigate(redirectUrl))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return <div>Auth</div>;
}
